import * as types from 'constants/downloadQr';
import {AjaxByToken,cancelRequestByKey,AjaxByGetByResumeClient} from 'utils/ajax';


  // 下载开始的加载和结束
const LOAD_DOWNLOAD_START = {type:types.LOAD_DOWNLOAD_START};
const LOAD_DOWNLOAD_DONE = {type:types.LOAD_DOWNLOAD_DONE};
//   下载二维码图片接口
const LOAD_DOWNLOAD_PIC = {type:types.LOAD_DOWNLOAD_PIC};

// 下载弹框的显示和隐藏
const SHOW_QR_MODAL = {type:types.SHOW_QR_MODAL};
const HIDE_QR_MODAL = {type:types.HIDE_QR_MODAL};
  // 显示Qr的弹框
export const showQrModal = () => (dispatch,getState) => {
    dispatch(SHOW_QR_MODAL);
  }
  // 隐藏Qr的弹框
export const hideQrModal = () => (dispatch,getState) => {
    dispatch(HIDE_QR_MODAL);
  }
  // 二维码下载接口
export const downloadQr = ()=> (dispatch,getState) => {
    const uri = 'createwxaqrcode';
    cancelRequestByKey(uri);
    dispatch(LOAD_DOWNLOAD_START);
    AjaxByToken(uri,{
        head: {
            transcode: 'L0043',
        },
        data:{
          skip:skip?skip+'':'0',
          count:"10",
          sort:'desc',
          key
        }
    })
    .then(res=>{
      dispatch(LOAD_DOWNLOAD_DONE);
  },err=>{
      dispatch(LOAD_DOWNLOAD_DONE);
  });
  }










// WEBPACK FOOTER //
// ./src/actions/downloadQR.js